import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Observable } from 'rxjs';

import { IUser } from 'user/user';

import { ChatUploadController } from './chat-upload.controller';
import { ChatUploadStore } from './chat-upload.store';

@Component({
	selector: 'spr-chat-upload',
	templateUrl: './chat-upload.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [ChatUploadStore, ChatUploadController],
	host: {
		class: 'flex items-stretch flex-col space-y-1',
	},
})
export class ChatUploadComponent {
	@Input() public user: IUser;
	@Input() public isModule: boolean;
	@Input() public overlayPanel: OverlayPanel;

	public uploadForm: FormGroup;
	public fileName$: Observable<string>;
	public isCreating$: Observable<boolean>;
	public isFormValid$: Observable<boolean>;
	public isUploading$: Observable<boolean>;

	constructor(private _controller: ChatUploadController) {
		this.uploadForm = _controller.form as FormGroup;
		this.isFormValid$ = _controller.selectValid();
		this.isUploading$ = _controller.isUploading$;
		this.isCreating$ = _controller.isCreating$;
		this.fileName$ = _controller.fileName$;
	}

	public get titlePlaceHolder(): string {
		return this.isModule
			? 'presentation.app.chat.upload.module.title'
			: 'presentation.app.chat.upload.document.title';
	}

	public onFileChange(e: any, file: HTMLInputElement) {
		this._controller.generateDocumentUrl(e.target.files[0]);
		file.value = null;
	}

	public onSubmitClick() {
		(this.isModule
			? this._controller.createModule(this.user)
			: this._controller.createDocument(this.user)
		).then((_) => this.overlayPanel.hide());
	}
}
